import { render, staticRenderFns } from "./biletallaktarim.vue?vue&type=template&id=73d8bbd4"
import script from "./biletallaktarim.vue?vue&type=script&lang=js"
export * from "./biletallaktarim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports